<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <transition name="fade">
          <div class="row" v-if="moduleInfoMessage">
            <div class="col-12">
              <div style="
                color: rgb(90, 90, 90);
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid rgb(90, 90, 90);
                margin-bottom: 20px;
                border-radius: 3px">
                {{ moduleInfoMessage }}
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div class="row" v-if="unitsErrorMessage || terminErrorMessage || moduleUnitsErrorMessage">
            <div class="col-12">
              <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
                {{ unitsErrorMessage }} {{ terminErrorMessage }} {{ moduleUnitsErrorMessage }}
              </div>
            </div>
          </div>
        </transition>

        <div v-if="missingDigitalSignatureMessage !== null"
             style="
                  margin-top: 5px;
                  color: #e65252;
                  font-size: 17px;
                  padding: 10px;
                  background: #F8F8F8;
                  border: 1px solid #e65252;
                  margin-bottom: 30px;
                  border-radius: 3px;">
          {{ missingDigitalSignatureMessage }}
        </div>

        <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
          <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
          <div class="col-auto text-right">
            <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
          </div>
        </div>

        <form @submit.prevent="submitForm" novalidate>
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
              <Datepicker
                  :disabled="isBilled || isCoachBilled"
                  v-model="formData.termin"
                  :required="true"
                  label="Termin"
                  position="down"
                  :validation="v$.termin"
                  :messages="v$.termin.required.$message"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12  ">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      :disabled="isBilled || isCoachBilled"
                      v-model="formData.startTime"
                      :required="true"
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Startzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      :disabled="isBilled || isCoachBilled"
                      v-model="formData.endTime"
                      :required="true"
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Endzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue v-model="formData.presence"
                         :disabled="isBilled || isCoachBilled"
                         :options="presenceDropdown"
                         :required="true"
                         label="Anwesenheit"
                         placeholder="Wählen Sie Anwesenheit"
                         :validation="v$.presence"
                         :messages="v$.presence.required.$message"
                         @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseCheckbox
                  :disabled="isBilled || isCoachBilled"
                  v-model="formData.overwrite"
                  :validation="v$.overwrite"
                  label="Überschreiben"
                  :required="true"
                  :messages="v$.overwrite.$errors.map((err) => err.$message).join(', ')"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseNumber
                  v-model="formData.units"
                  label="Einheiten"
                  disabled="disabled"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue v-model="formData.coachType"
                         :disabled="isBilled || isCoachBilled"
                         :options="coachTypeDropdown"
                         :required="true"
                         :is-clear="true"
                         label="Coachart"
                         placeholder="Wählen Sie Coachart"
                         :validation="v$.coachType"
                         :messages="v$.coachType.required.$message"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.signature"
                    :disabled="isBilled || isCoachBilled || coachingData?.requiresSignature"
                    :validation="v$.signature"
                    label="Unterschrift"
                    :required="true"
                    :labelPosition="'right'"
                    :messages="v$.signature.$errors.map((err) => err.$message).join(', ')"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12"
                 v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.billed"
                    :disabled="isBilled"
                    :validation="v$.billed"
                    label="Abgerechnet"
                    :required="true"
                    :labelPosition="'right'"
                    :messages="v$.billed.$errors.map((err) => err.$message).join(', ')"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12"
                 v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <div class=" mt-4">
                <BaseCheckbox
                    v-model="formData.paid"
                    :disabled="isCoachBilled"
                    label="Bezahlt"
                    :required="true"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.homeVisit"
                    :disabled="isBilled || isCoachBilled"
                    :validation="v$.homeVisit"
                    label="Hausbesuch"
                    :required="true"
                    :labelPosition="'right'"
                    :messages="v$.homeVisit.$errors.map((err) => err.$message).join(', ')"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-8 col-sm-12">
              <SelectVue v-model="formData.moduleId"
                         :disabled="isBilled || isCoachBilled"
                         :options="moduleDropdown"
                         :required="true"
                         :is-clear="true"
                         label="Modul"
                         placeholder="Modul auswählen"
                         :validation="v$.moduleId"
                         :messages="v$.moduleId.required.$message"
                         @update:modelValue="onChangeModule"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 position-relative">
              <div class="position-absolute" style="right: 0; padding-right: 10px;">
                <div class="status-pill p-2 rounded-full"
                     :class="{green: checkMissingMetingForSectionNumber(sectionNumberList, originalSectionNumber),
                              red: !checkMissingMetingForSectionNumber(sectionNumberList, originalSectionNumber)}">
                </div>
              </div>
              <BaseNumber
                  v-model="formData.sectionNumber"
                  :validation="v$.sectionNumber"
                  :messages="v$.sectionNumber?.required?.$message"
                  :label="$t('general.section')"
                  :disabled="!updateAsAdmin"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12"
                 v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'">
              <SelectVue
                  v-model="formData.coachId"
                  :disabled="isCoachBilled"
                  :options="coachDropdown"
                  :required="true"
                  :is-clear="true"
                  label="Coach"
                  placeholder="Trainer auswählen"/>
            </div>
          </div>

          <div class="row">
            <FirstInterviewSignaturePanel
                :operationType="operationType"
                :currentUserRole="currentUserRole"
                :firstInterviewId="firstInterviewId"
                :currentDigitalSignature="currentDigitalSignature"
                :isDigitalSignature="isDigitalSignature"
                :missingDigitalSignatureForFirstInterview="missingDigitalSignatureForFirstInterview"
                :updatedByAdmin="false"
                @open-signature="handleDigitalSignatureModal"/>
          </div>

          <div class="accordion mt-5">
            <!-- Accordion Item 1 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(1)">
                <h6 :style="{ color: 'var(--primary)' }">Gesundheitsfragen</h6>
              </div>
              <div v-if="activeAccordion === 1" class="accordion-body">
                <AccordionItem
                    title="Einschränkung"
                    :items="formData.limitations"
                    itemTitleLabel="Gesundheitliche Einschränkung"
                    itemDescriptionLabel="Auswirkung"
                    @addItem="(newItem) => addItem('limitations', newItem)"
                    @deleteItem="(index) => removeItem('limitations', index)"/>
                <AccordionItem
                    title="Abhängigkeit"
                    :items="formData.dependencies"
                    itemTitleLabel="Art der Abhängigkeit"
                    itemDescriptionLabel="Beschreibung (Menge/Substanz)"
                    @addItem="(newItem) => addItem('dependencies', newItem)"
                    @deleteItem="(index) => removeItem('dependencies', index)"/>
                <AccordionItem
                    title="Ärztliche Versorgung"
                    :items="formData.medicalCares"
                    itemTitleLabel="Arzt"
                    itemDescriptionLabel="Kontaktdaten"
                    :dropdownOptions="doctorTypeDropdown"
                    @addItem="(newItem) => addItem('medicalCares', newItem, true)"
                    @deleteItem="(index) => removeItem('medicalCares', index)"/>
                <AccordionItem
                    title="Medikamente"
                    :items="formData.medications"
                    itemTitleLabel="Handelsname"
                    itemDescriptionLabel="Indikation"
                    @addItem="(newItem) => addItem('medications', newItem)"
                    @deleteItem="(index) => removeItem('medications', index)"/>
                <AccordionItem
                    title="Weitere ambulante Behandlung und Hilfeleistung"
                    :items="formData.treatmentsAndAssistance"
                    itemTitleLabel="Art der Hilfeleistung"
                    itemDescriptionLabel="Kontaktdaten"
                    :dropdownOptions="assistanceTypeDropdown"
                    @addItem="(newItem) => addItem('treatmentsAndAssistance', newItem, true)"
                    @deleteItem="(index) => removeItem('treatmentsAndAssistance', index)"/>
                <AccordionItem
                    title="Stationäre Behandlung der letzten Jahre"
                    :items="formData.treatmentInYears"
                    itemTitleLabel="Krankenhaus"
                    itemDescriptionLabel="Beschreibung / Folgen"
                    @addItem="(newItem) => addItem('treatmentInYears', newItem)"
                    @deleteItem="(index) => removeItem('treatmentInYears', index)"/>
              </div>
            </div>

            <!-- Accordion Item 2 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(2)">
                <h6 :style="{ color: 'var(--primary)' }">Ressourcen und Kompetenzen</h6>
              </div>
              <div v-if="activeAccordion === 2" class="accordion-body">
                <AccordionItem
                    title="Ressourcen und Kompetenzen"
                    :items="formData.resourceAndSkills"
                    itemTitleLabel="Ressourcen und Kompetenzen"
                    itemDescriptionLabel="Was und wie?"
                    @addItem="(newItem) => addItem('resourceAndSkills', newItem)"
                    @deleteItem="(index) => removeItem('resourceAndSkills', index)"/>
              </div>
            </div>

            <!-- Accordion Item 3 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(3)">
                <h6 :style="{ color: 'var(--primary)' }">Arbeitsbiografischer Kontext</h6>
              </div>
              <div v-if="activeAccordion === 3" class="accordion-body">
                <div class="row">
                  <div class="col-6">
                    <SelectVue
                        v-model="formData.graduation"
                        :options="graduationTypeDropdown"
                        label="Schulabschluss"
                        placeholder="Arten von Abschlüssen"/>
                  </div>
                  <div class="col-12 mt-4">
                    <TextEditor
                        v-model="formData.education"
                        @update:model-value="formData.education = $event"
                        :inputStyle="{ height: '200px' }"
                        label="Ausbildung"/>
                  </div>
                  <div class="col-12 mt-4">
                    <TextEditor
                        v-model="formData.employmentBiography"
                        @update:model-value="formData.employmentBiography = $event"
                        :inputStyle="{ height: '200px' }"
                        label="Erwerbsbiographie"/>
                  </div>
                  <div class="col-12 mt-4">
                    <TextEditor
                        v-model="formData.leaveTheProfession"
                        @update:model-value="formData.leaveTheProfession = $event"
                        :inputStyle="{ height: '200px' }"
                        label="Wann und wie aus dem Beruf ausgeschieden"/>
                  </div>
                </div>
              </div>
            </div>

            <!-- Accordion Item 4 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(4)">
                <h6 :style="{ color: 'var(--primary)' }">Einschränkung</h6>
              </div>
              <div v-if="activeAccordion === 4" class="accordion-body">
                <AccordionItem
                    title="Einschränkung"
                    :items="formData.obstacles"
                    itemTitleLabel="Problemlage / Hemmnis"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('obstacles', newItem)"
                    @deleteItem="(index) => removeItem('obstacles', index)"/>
                <AccordionItem
                    title="Handlungsplan"
                    :items="formData.steps"
                    itemTitleLabel="Ziel"
                    itemDescriptionLabel="Umsetzung"
                    @addItem="(newItem) => addItem('steps', newItem)"
                    @deleteItem="(index) => removeItem('steps', index)"/>
                <AccordionItemWithDropdown
                    title="Coaching"
                    :items="formData.typesOfCoaching"
                    itemTitleLabel="Art des Coachings"
                    :dropdownOptions="typesOfCoachingDropdown"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('typesOfCoaching', newItem)"
                    @deleteItem="(index) => removeItem('typesOfCoaching', index)"/>
              </div>
            </div>
          </div>

          <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

          <div
              v-if="!unitsErrorMessage && !terminErrorMessage && !moduleUnitsErrorMessage && canSeeCreateNewMeetingButton"
              class="d-flex justify-content-center w-100 mt-5">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>

    <Modal
        v-model="showDigitalSignatureModal"
        title="Digitale Unterschrift"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-md"
        :hide-footer="true"
        classFooter="justify-content-center">
      <PrivateCoachingDigitalSignatureForm
          :meetingId="firstInterviewId"
          :coachingId="coachingId"
          meetingType="firstInterview"
          v-model:missingDigitalSignature="missingDigitalSignatureForFirstInterview"
          v-model:submitForm="submitFormWatch"/>
    </Modal>
  </PageTemplate>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {addDeletedCoachToDropdown, addDeletedModuleToDropdown} from '@/shared/portal/commonFunctions';
import {
  checkCoachingStartDateForMICV1,
  checkMissingMetingForSectionNumber,
  mapData,
  portalPrivateCoachingCheckModule,
} from '@/shared/portal/privateCoachingFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import AccordionItemWithDropdown from '@/views/App/Portal/GroupCoaching/FirstInterview/AccordionItemWithDropdown.vue';
import CoachingOverviewData from '@/views/App/Portal/PrivateCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/PrivateCoaching/FirstInterview/Accordion/AccordionItem.vue';
import Menu from '@/views/App/Portal/PrivateCoaching/Menu.vue';
import PrivateCoachingDigitalSignatureForm
  from '@/views/App/Portal/PrivateCoaching/PrivateCoachingDigitalSignatureForm.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import BaseToggle from "@/components/base/BaseToggle.vue";
import FirstInterviewSignaturePanel from "@/components/FirstInterviewSignaturePanel.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const micNewUnitsCalculationStartFrom = process.env.VUE_APP_MIC_NEW_UNITS_CALCULATION_START_FROM
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachingData = ref('');
const route = useRoute();
const coachingId = route.params.id;
const firstInterviewId = ref(null);
const operationType = ref('');
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const coachDropdown = ref([]);
const moduleDropdown = ref([]);
const doctorTypeDropdown = ref([]);
const assistanceTypeDropdown = ref([]);
const graduationTypeDropdown = ref([]);
const typesOfCoachingDropdown = ref([]);
const isLoaded = ref(false);
const unitsErrorMessage = ref('');
const terminErrorMessage = ref('');
const moduleUnitsErrorMessage = ref('');
const moduleInfoMessage = ref('');
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const activeAccordion = ref(null); // Tracks the currently open accordion item
const missingDigitalSignature = ref(null);
const missingDigitalSignatureMessage = ref(null);
const isDigitalSignature = ref(false);
const showDigitalSignatureModal = ref(false);
const submitFormWatch = ref(false);
const missingDigitalSignatureForFirstInterview = ref(false);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const originalSectionNumber = ref(0)
const sectionNumberList = ref([])
const currentDigitalSignature = ref(null)

watch(submitFormWatch, async () => {
  showDigitalSignatureModal.value = false;
  await getFirstInterviewData(coachingId);
});

const formData = ref({
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  moduleId: null,
  sectionNumber: null,
  graduation: '',
  education: '',
  employmentBiography: '',
  leaveTheProfession: '',
  limitations: [],
  dependencies: [],
  medicalCares: [],
  medications: [],
  treatmentsAndAssistance: [],
  treatmentInYears: [],
  resourceAndSkills: [],
  obstacles: [],
  steps: [],
  typesOfCoaching: [],
});

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  overwrite: requiredRule(t),
  units: requiredRule(t),
  signature: requiredRule(t),
  billed: requiredRule(t),
  paid: requiredRule(t),
  homeVisit: requiredRule(t),
  moduleId: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer

    if (firstInterviewId.value) {
      if (updateAsAdmin.value) {
        await portalPrivateCoachingService.updateAsAdminMICFirstInterview(formData.value, +firstInterviewId.value);
      } else {
        await portalPrivateCoachingService.updateMICFirstInterview(formData.value, +firstInterviewId.value);
      }
    } else {
      await portalPrivateCoachingService.createMICFirstInterview(formData.value);
    }

    await getFirstInterviewData(coachingId);
    await getPrivateCoachingData(coachingId)

    activeAccordion.value = null;
    updateAsAdmin.value = false // IMPORTANT !!!
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData(privateCoachingId) {
  try {
    CloseToast();
    const {data} = await privateCoachingService.getPrivateCoaching(+privateCoachingId);
    coachingData.value = data.data;
    operationType.value = data.data.nameOfCoaching.operationType;
    isDigitalSignature.value = data.data.digitalSignature;
  } catch (error) {
    await router.push({name: 'privateCoachingNewAndActiveList'});
    await ErrorToast(error);
  }
}

async function getFirstInterviewData(privateCoachingId) {

  try {

    const {data} = await portalPrivateCoachingService.getFirstInterviewData(privateCoachingId);
    const {firstInterview} = data?.data;
    missingDigitalSignature.value = data?.data?.missingDigitalSignature;
    missingDigitalSignatureMessage.value = data?.data?.missingDigitalSignatureMessage;
    sectionNumberList.value = data.data.sectionNumberList

    if (firstInterview) {
      currentDigitalSignature.value = firstInterview?.digitalSignatureBase64;
      isBilled.value = firstInterview?.invoiced;
      isCoachBilled.value = firstInterview?.coachInvoiced;

      // Save original values for update as admin
      originalIsBilled.value = firstInterview.invoiced;
      originalIsCoachBilled.value = firstInterview.coachInvoiced;
      originalSectionNumber.value = firstInterview.sectionNumber

      if (!firstInterview.digitalSignatureImage) {
        missingDigitalSignatureForFirstInterview.value = true;
      }

      const coachId = firstInterview?.coach?.id;
      const moduleId = firstInterview?.module?.id;
      const limitationsData = mapData(firstInterview?.limitations || []);
      const dependenciesData = mapData(firstInterview?.dependencies || []);
      const medicalCaresData = mapData(firstInterview?.medicalCares || []);
      const medicationsData = mapData(firstInterview?.medications || []);
      const treatmentsAndAssistanceData = mapData(firstInterview?.treatmentsAndAssistance || []);
      const treatmentInYearsData = mapData(firstInterview?.treatmentInYears || []);
      const resourceAndSkillsData = mapData(firstInterview?.resourceAndSkills || []);
      const obstaclesData = mapData(firstInterview?.obstacles || []);
      const stepsData = mapData(firstInterview?.steps || []);
      const typesOfCoachingData = mapData(firstInterview?.typesOfCoaching || []);

      addDeletedCoachToDropdown(firstInterview?.coach, coachDropdown);
      addDeletedModuleToDropdown(firstInterview?.module, moduleDropdown);

      firstInterviewId.value = firstInterview?.id;

      formData.value = {
        ...firstInterview,
        coachId: coachId,
        moduleId: moduleId,
        limitations: limitationsData,
        dependencies: dependenciesData,
        medicalCares: medicalCaresData,
        medications: medicationsData,
        treatmentsAndAssistance: treatmentsAndAssistanceData,
        treatmentInYears: treatmentInYearsData,
        resourceAndSkills: resourceAndSkillsData,
        obstacles: obstaclesData,
        steps: stepsData,
        typesOfCoaching: typesOfCoachingData,
      };
    }
  } catch (error) {
    await ErrorToast(error);
  }

}

async function getAssignedCoaches(privateCoachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedCoaches(+privateCoachingId);
    coachDropdown.value = data.data.map(item => ({
      label: `${item.fullName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedModules(privateCoachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedModules(+privateCoachingId);
    moduleDropdown.value = data.data.map(item => ({
      label: `${item.name}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

// Accordion
const toggleAccordion = (index) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type, newItem, isDropdown = false) => {
  formData.value[type].push(newItem);
};

const removeItem = (type, index) => {
  formData.value[type].splice(index, 1);
};

// Function to calculate time difference !!!!
const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
    moduleInfoMessage.value = '';

    onChangeUnits(units); // Check if units are round

    const parsedValue = parseFloat(units);
    if (parsedValue === 1 || parsedValue === 2) { // Units must be 1 or 2
      // Check a presence type
      if ((formData.value.presence)) {
        if (formData.value.presence === 'anwesend') {
          units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
        } else {
          units = 1;
        }
      }

      // If presence is selected and overview is true, calculate units
      if (formData.value.overwrite === true) {
        units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
      }

      onChangeModule(formData.value.moduleId);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (!Number.isInteger(parsedValue)) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (parsedValue > 2) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else {
    unitsErrorMessage.value = '';
  }
}

async function onChangeModule(newValue) {
  try {
    if (newValue) {
      const {data} = await portalPrivateCoachingService.getSumUnitsDoneForModule(
          +coachingId, +newValue,
      );

      const [errorMessage, infoMessage] = portalPrivateCoachingCheckModule(data, formData, updateAsAdmin.value);

      moduleInfoMessage.value = infoMessage;
      moduleUnitsErrorMessage.value = errorMessage;

    } else {
      moduleInfoMessage.value = '';
      moduleUnitsErrorMessage.value = '';
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

// Watchers for startTime and endTime
//watch(
//    () => [
//      formData.value.startTime,
//      formData.value.endTime,
//      formData.value.presence,
//      formData.value.overwrite,
//    ],
//    calculateTimeDifference,
//);

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  coachTypeDropdown.value = getEnums?.value?.portalCoachTypes || [];
  doctorTypeDropdown.value = getEnums?.value?.doctorTypes || [];
  assistanceTypeDropdown.value = getEnums?.value?.assistanceTypes || [];
  graduationTypeDropdown.value = getEnums?.value?.graduationTypes || [];
  typesOfCoachingDropdown.value = getEnums?.value?.typesOfCoaching || [];
}

// async function checkCoachingStartDateForOldLogic(coachingId) {
//   const [day, month, year] = coachingData?.value.startDate.split('.'); // e.g., '2024-10-06'
//   const coachingStartDate = `${year}-${month}-${day}`;
//   const newLogicStartFrom = '2024-10-07'; // Target date in ISO format IMPORTANT !!!!!!!!
//
//   if (Number(coachingId) !== 9950 && (coachingStartDate >= newLogicStartFrom)) {
//     await router.push({name: 'privateCoachingMicFirstInterviewV2Form', params: {coachingId}});
//   }
// }

function handleDigitalSignatureModal() {
  CloseToast();
  showDigitalSignatureModal.value = true;
}

const canSeeCreateNewMeetingButton = computed(() => {
  if (currentUserRole === 'ROLE_ADMIN') {
    return true;
  } else {
    return true;
    // return missingDigitalSignatureMessage.value === null;
  }
});

const showUpdateAsAdminButton = computed(() => {
  if (
      (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
      (originalIsBilled.value || originalIsCoachBilled.value)
  ) {
    return true;
  }
  return false;
})

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;

    formRules.value = {
      ...formRules.value,
      sectionNumber: requiredRule(t),
    }
  } else {
    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;

    formRules.value = {
      ...formRules.value,
      sectionNumber: '',
    }
  }
}

onMounted(async () => {
  await Promise.all([
    getPrivateCoachingData(coachingId),
    getFirstInterviewData(coachingId),
    getAssignedCoaches(coachingId),
    getAssignedModules(coachingId),
    getEnumsDropdown(),
  ]);

  // this must be at the end !!!
  checkCoachingStartDateForMICV1(coachingData, coachingId)

  isLoaded.value = true;
});
</script>

<style scoped>

</style>